
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/documentServices/dsDebugTools/dsDebugger.scss.css.virtualfile';
        module.exports = {"container":"_container_1ujlx_1"};